import { SkeletonElement } from '@bts-web/core-features/common';
import { stack, css } from '@bts-web/utils-style-engine';

export const SelfDeclarationScreenSkeleton = () => (
  <div
    className={stack({
      gap: 'large',
      paddingX: 'medium',
      paddingY: 'small',
      width: '100%',
    })}
    data-testid="self-declaration-skeleton-container"
  >
    <div className={stack({ gap: 'small' })}>
      <SkeletonElement height="24px" width="100px" borderRadius="30px" />

      <div
        className={css({
          display: 'flex',
          gap: 'small',
          justifyContent: 'center',
          borderBottomWidth: '1px',
          borderBottomColor: 'neutrals.divider',
          paddingBottom: 'small',
          paddingTop: 'extra_small_2',
        })}
      >
        <SkeletonElement width="40px" height="40px" borderRadius="30px" />
        <div
          className={stack({
            alignItems: 'start',
            gap: 'extra_small_2',
            flex: '1',
          })}
        >
          <SkeletonElement height="24px" width="100px" borderRadius="30px" />
          <SkeletonElement height="24px" width="140px" borderRadius="30px" />
        </div>
      </div>

      <div className={stack({ gap: 'medium' })}>
        <SelfDeclarationScreenFieldSkeleton keyWidth="150px" widthCheckbox />
        <SelfDeclarationScreenFieldSkeleton keyWidth="120px" />
        <SelfDeclarationScreenFieldSkeleton keyWidth="150px" />
      </div>
    </div>
  </div>
);

const SelfDeclarationScreenFieldSkeleton = ({
  widthCheckbox = false,
  keyWidth,
}: {
  widthCheckbox?: boolean;
  keyWidth: string;
}) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: 'extra_small_2',
    })}
  >
    <SkeletonElement height="20px" width={keyWidth} borderRadius="4px" />
    <SkeletonElement
      height="54px"
      width="100%"
      borderRadius="4px"
      className={css({
        mt: 'extra_small_4',
      })}
    />

    {widthCheckbox && (
      <div
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <SkeletonElement height="18px" width="60%" borderRadius="30px" />
        <SkeletonElement height="20px" width="40px" borderRadius="30px" />
      </div>
    )}
  </div>
);
